<template>    
    <div id="mainContent">
      <TronHeader />
      <main class="home pb-0 home-page notranslate">
        <TronSummary />
        <TronBlocks />                
      </main>
    </div>  
</template>

<script>

import TronHeader from "@/components/TronHeader.vue";
import TronSummary from "@/components/TronSummary.vue";
import TronBlocks from "@/components/TronBlocks.vue";
import TronTransactions from "@/components/TronTransactions.vue";


export default {  
  name: 'HomeView',
  components: {
    TronHeader,
    TronSummary,
    TronBlocks,
    TronTransactions,
  },
  data() {
    return {
      loading: false,     
    }
  },
  mounted() {
    
  },
  methods: {
    
  }
}
</script>

<style src="@/assets/styles/main.css"></style>
<style src="@/assets/styles/mainlite.css"></style>
<style src="@/assets/styles/home.css"></style>
<style src="@/assets/styles/styles.css"></style>

<style>
.tron-icon {
    fill: currentColor;
    height: 1em;
    overflow: hidden;
    vertical-align: -.15em;
    width: 1em;
}
</style>